module.exports = __webpack_public_path__ + "ath_game_web/img/5.4.0807076d.png";